import { render, staticRenderFns } from "./ViewElectricity.vue?vue&type=template&id=70010320&"
import script from "./ViewElectricity.vue?vue&type=script&lang=js&"
export * from "./ViewElectricity.vue?vue&type=script&lang=js&"
import style0 from "./ViewElectricity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewElectricity.vue"
export default component.exports